// ############ fonts ############
import "vendor/able-pro/files/assets/icon/icofont/css/icofont.css"
import "vendor/able-pro/files/assets/icon/feather/css/feather.css"

import "./application.scss"
// ############polyfill############
import 'whatwg-fetch';
import "polyfill/closest";
import "polyfill/foreach";
import "polyfill/custom_event";
// const StickyState = require('sticky-state');
// ############  js   ############
import "feather-icons/dist/feather.min.js";
import 'rails-ujs';
import "jquery-ui";
import "popper.js";
import "bootstrap";
import "node-waves/dist/waves.min.js";
import "jquery-slimscroll";
import 'jquery-serializejson/jquery.serializejson';
import "moment";
import "flatpickr";

import "vendor/able-pro/files/assets/js/pcoded.min.js";

// ############  mixs  ############
import "mixs/shared/paginate.ts"
import "mixs/shared/black-over.ts"
import "mixs/shared/expandable.ts";
import "mixs/base/table_mixin.ts";

import "mixs/forms/users/save.ts";
import "mixs/forms/users/search.ts";
import "mixs/forms/user_settings/mail_setting/save.ts";
import "mixs/forms/heat_treatments/search.ts";
import "mixs/forms/heat_treatments/save.ts";
import "mixs/forms/clients/search.ts";
import "mixs/forms/clients/save.ts";
import "mixs/forms/orders/search.ts";
import "mixs/forms/orders/search-for-csv.ts";
import "mixs/forms/orders/save.ts";
import "mixs/forms/orders/checking_orders_csv.ts";
import "mixs/forms/orders/checking_jobno.ts";
import "mixs/forms/orders/under.ts";
import "mixs/forms/orders/status.ts";
import "mixs/forms/orders/files.ts";
import "mixs/forms/materials/search.ts";
import "mixs/forms/materials/save.ts";
import "mixs/forms/products/search.ts";
import "mixs/forms/products/save.ts";
import "mixs/forms/teams/search.ts";
import "mixs/forms/teams/save.ts";
import "mixs/forms/todos/save.ts";
import "mixs/forms/todos/save.ts";
import "mixs/forms/locations/search.ts";
import "mixs/forms/locations/save.ts";
import "mixs/forms/locations/people/save.ts";
import "mixs/forms/schedules/save.ts";
import "mixs/forms/schedules/destroy.ts";
import "mixs/forms/tasks/save.ts";
import "mixs/forms/tasks/save.ts";
import "mixs/forms/tasks/memos/save.ts";
import "mixs/forms/tasks/deliveries/search.ts";
import "mixs/forms/planner/search.ts";
import "mixs/forms/comments/save.ts";
import "mixs/forms/comments/reply.ts";
import "mixs/forms/delivery_options/save.ts";
import "mixs/forms/dialogs/approved-nextstep.ts";

import "mixs/inputs/checkbox-fade-in.ts";
import "mixs/inputs/file.ts";
import "mixs/inputs/text.ts";
import "mixs/inputs/textfield.ts";
import "mixs/inputs/textarea.ts";
import "mixs/inputs/hidden.ts";
import "mixs/inputs/password.ts";
import "mixs/inputs/checkbox-multiple.ts";
import "mixs/inputs/checkbox-select.ts";
import "mixs/inputs/checkbox-switch.ts";
import "mixs/inputs/radio-multiple.ts";
import "mixs/inputs/typeahead.ts";
import "mixs/inputs/number-comma.ts";
import "mixs/inputs/submit.ts";
import "mixs/inputs/number.ts";
import "mixs/inputs/select.ts";
import "mixs/inputs/date.ts";
import "mixs/inputs/daterange.ts";
import "mixs/inputs/complex/select-phase.ts";
import "mixs/inputs/complex/checkbox-phase.ts";
import "mixs/inputs/complex/number-and-partition.ts";
import "mixs/inputs/complex/to-whom.ts";
import "mixs/inputs/complex/radio-under";
import "mixs/inputs/complex/radio-status";
import "mixs/inputs/complex/location-inserter";
import "mixs/inputs/complex/search-comma";
import "mixs/inputs/complex/checkbox-check-reports";
import "mixs/inputs/complex/check-special-reports";
import "mixs/inputs/complex/delivery-attachments";
import "mixs/inputs/complex/delivery-other-attachments";
import "mixs/inputs/complex/delivery-attachments-for-circle";
import "mixs/inputs/search/switch";
import "mixs/inputs/search/checkbox";
import "mixs/inputs/search/radio-order";
import "mixs/inputs/search/select-phase";
import "mixs/inputs/search/daterange";
import "mixs/inputs/without-label/checkall";

import "mixs/logs/calendar.ts"
import "mixs/logs/jump.ts"

import "mixs/histories/histories.ts"
import "mixs/histories/base.ts"
import "mixs/histories/show.ts"
import "mixs/histories/planner.ts";
import "mixs/todays/index.ts"
import "mixs/todays/deliveries.ts"
import "mixs/todays/deliveries/task.ts"
import "mixs/todays/deliveries/date-ui.ts"
import "mixs/myschedules/index.ts"
import "mixs/planner/title.ts"
import "mixs/orders/result-checking-orders-csv.ts";
import "mixs/orders/info-expandable.ts";
import "mixs/orders/planner.ts"
import "mixs/orders/index.ts"
import "mixs/orders/info.ts"
import "mixs/orders/today.ts"
import "mixs/orders/today-calendar.ts"
import "mixs/orders/approvals/stamp.ts"
import "mixs/orders/planner/orders.ts"
import "mixs/orders/planner/props.ts"
import "mixs/orders/planner/lines.ts"
import "mixs/orders/planner/schedules.ts"
import "mixs/orders/planner/scroll.ts"
import "mixs/orders/planner/warnings.ts"
import "mixs/orders/planner/search-tags.ts"
import "mixs/orders/planner/show-all-phases.ts"
import "mixs/orders/planner/dialog/create-schedule.ts"
import "mixs/orders/planner/dialog/save-tasks-memo.ts"
import "mixs/orders/planner/dialog/tooltip-schedule.ts"
import "mixs/orders/planner/dialog/tooltip-orders-phase.ts"
import "mixs/orders/planner/dialog/line-menu.ts"
import "mixs/orders/planner/dialog/update-under.ts"
import "mixs/orders/planner/dialog/update-status.ts"
import "mixs/orders/planner/schedules/cell.ts";
import "mixs/orders/planner/schedules/memo.ts";
import "mixs/orders/planner/date-ui.ts"
import "mixs/orders/planner/deadline.ts"
import "mixs/orders/planner/line-back-forward.ts";
import "mixs/orders/planner/line-ui/menu.ts"
import "mixs/orders/planner/line-ui/cells.ts"
import "mixs/orders/planner/line-ui/ind-cell.ts"
import "mixs/orders/planner/line-ui/schedules.ts"
import "mixs/orders/planner/line-ui/schedules-cell.ts"
import "mixs/orders/planner/line-ui/schedules-left-right.ts"
import "mixs/orders/planner/task/editor.ts"
import "mixs/orders/planner/task/indicators.ts"
import "mixs/orders/planner/tooltip/detail.ts"
import "mixs/orders/planner/tooltip/orders-phase.ts"
import "mixs/tasks/today.ts"
import "mixs/tasks/delivered-cell.ts";
import "mixs/tasks/delivered-count.ts";
import "mixs/tasks/delivered-total.ts";
import "mixs/tasks/schedules-text.ts"
import "mixs/tasks/schedules-calendar.ts"
import "mixs/tasks/schedules-cell.ts"
import "mixs/comments/index";
import "mixs/comments/comment";
import "mixs/notifications/header";
import "mixs/notifications/base";
import "mixs/notifications/read-indicator";
import "mixs/notifications/items/item";
import "mixs/notifications/table";
import "mixs/calendars/two_weeks";
import "mixs/calendars/material_lots";
import "mixs/calendars/daily";
import "mixs/calendars/phase";
import "mixs/calendars/date-ui";

import "mixs/devs/gen-calendar";

// ############  tags  ############
import "tags/shared/paginate.tag";
import "tags/shared/black-over.tag";
import "tags/shared/raw.tag";

import "tags/dialogs/basic.tag";
import "tags/dialogs/approved-nextstep.tag";
import "tags/forms/destroy.tag";
import "tags/forms/users/save.tag";
import "tags/forms/users/search.tag";
import "tags/forms/user_settings/mail_setting/save.tag";
import "tags/forms/heat_treatments/save.tag";
import "tags/forms/heat_treatments/search.tag";
import "tags/forms/clients/save.tag";
import "tags/forms/clients/search.tag";
import "tags/forms/orders/save.tag";
import "tags/forms/orders/search.tag";
import "tags/forms/orders/search-form.tag";
import "tags/forms/orders/search-for-csv.tag";
import "tags/forms/orders/checking_orders_csv.tag";
import "tags/forms/orders/checking_jobno.tag";
import "tags/forms/orders/under.tag";
import "tags/forms/orders/status.tag";
import "tags/forms/orders/files.tag";
import "tags/forms/orders/files/create.tag";
import "tags/forms/orders/files/destroy.tag";
import "tags/forms/materials/save.tag";
import "tags/forms/materials/search.tag";
import "tags/forms/products/save.tag";
import "tags/forms/products/search.tag";
import "tags/forms/teams/save.tag";
import "tags/forms/teams/search.tag";
import "tags/forms/todos/save.tag";
import "tags/forms/locations/save.tag";
import "tags/forms/locations/search.tag";
import "tags/forms/locations/people/save.tag";
import "tags/forms/schedules/destroy.tag";
import "tags/forms/schedules/create.tag";
import "tags/forms/schedules/update.tag";
import "tags/forms/tasks/update.tag";
import "tags/forms/tasks/memos/save.tag";
import "tags/forms/tasks/deliveries/search.tag";
import "tags/forms/planner/search.tag";
import "tags/forms/comments/save.tag";
import "tags/forms/comments/reply.tag";
import "tags/forms/delivery_options/save.tag";
import "tags/forms/delivery_options/search.tag";
import "tags/forms/dialogs/approved-nextstep.tag";


import "tags/inputs/checkbox-fade-in.tag";
import "tags/inputs/file.tag";
import "tags/inputs/textfield.tag";
import "tags/inputs/textarea.tag";
import "tags/inputs/hidden.tag";
import "tags/inputs/password.tag";
import "tags/inputs/checkbox-multiple.tag";
import "tags/inputs/checkbox-select.tag";
import "tags/inputs/checkbox-switch.tag";
import "tags/inputs/radio-multiple.tag";
import "tags/inputs/without-label/textfield.tag";
import "tags/inputs/without-label/textarea.tag";
import "tags/inputs/without-label/number-plus.tag";
import "tags/inputs/without-label/typeahead.tag";
import "tags/inputs/without-label/typeahead-single.tag";
import "tags/inputs/without-label/checkall.tag";
import "tags/inputs/without-label/submit-to-destroy.tag";
import "tags/inputs/without-label/radio-multiple.tag";
import "tags/inputs/typeahead-single.tag";
import "tags/inputs/typeahead-multiple.tag";
import "tags/inputs/typeahead-dubble.tag";
import "tags/inputs/select.tag";
import "tags/inputs/submit.tag";
import "tags/inputs/number.tag";
import "tags/inputs/number-comma.tag";
import "tags/inputs/date.tag";
import "tags/inputs/daterange.tag";
import "tags/inputs/search/keyword.tag";
import "tags/inputs/search/submit.tag";
import "tags/inputs/search/textfield.tag";
import "tags/inputs/search/checkbox.tag";
import "tags/inputs/search/switch.tag";
import "tags/inputs/search/radio-order.tag";
import "tags/inputs/search/select-phase.tag";
import "tags/inputs/search/daterange.tag";
import "tags/inputs/complex/select-phase.tag";
import "tags/inputs/complex/checkbox-phase.tag";
import "tags/inputs/complex/number-and-partition.tag";
import "tags/inputs/complex/comment-textarea.tag";
import "tags/inputs/complex/to-whom.tag";
import "tags/inputs/complex/radio-under.tag";
import "tags/inputs/complex/radio-status.tag";
import "tags/inputs/complex/location-inserter.tag";
import "tags/inputs/complex/search-comma.tag";
import "tags/inputs/complex/checkbox-check-todo.tag";
import "tags/inputs/complex/checkbox-check-reports.tag";
import "tags/inputs/complex/check-special-reports.tag";
import "tags/inputs/complex/delivery-attachments.tag";
import "tags/inputs/complex/delivery-other-attachments.tag";
import "tags/inputs/complex/delivery-attachments-for-circle.tag";


import "tags/histories/show.tag";
import "tags/histories/created.tag";
import "tags/histories/updated.tag";
import "tags/histories/updated-reverse.tag";
import "tags/histories/updated-polymorphic.tag";
import "tags/histories/planner.tag";
import "tags/histories/order/created.tag";
import "tags/histories/order/updated.tag";
import "tags/histories/orders-phase/created.tag";
import "tags/histories/orders-phase/updated.tag";
import "tags/histories/orders-phase/destroyed.tag";
import "tags/histories/line/created.tag";
import "tags/histories/line/destroyed.tag";
import "tags/histories/schedule/created.tag";
import "tags/histories/schedule/updated.tag";
import "tags/histories/schedule/destroyed.tag";
import "tags/histories/task/created.tag";
import "tags/histories/task/updated.tag";
import "tags/histories/task/destroyed.tag";
import "tags/histories/taskable/updated.tag";
import "tags/histories/tasks-memo/created.tag";
import "tags/histories/tasks-memo/updated.tag";
import "tags/histories/tasks-memo/destroyed.tag";
import "tags/histories/approval/required-to-seller.tag";
import "tags/histories/approval/required-to-sales-manager.tag";
import "tags/histories/approval/required-to-exective.tag";
import "tags/histories/approval/approved-by-seller.tag";
import "tags/histories/approval/canceled-by-seller.tag";
import "tags/histories/approval/approved-by-sales-manager.tag";
import "tags/histories/approval/canceled-by-sales-manager.tag";
import "tags/histories/approval/approved-by-exective.tag";
import "tags/histories/approval/canceled-by-exective.tag";

import "tags/logs/calendar.tag";
import "tags/logs/jump.tag";

import "tags/downloads/index.tag";
import "tags/todays/index.tag";
import "tags/todays/deliveries.tag";
import "tags/todays/deliveries/task.tag";
import "tags/todays/deliveries/download-btn.tag";
import "tags/todays/deliveries/labels-btn.tag";
import "tags/todays/deliveries/letters-btn.tag";
import "tags/todays/deliveries/save-btn.tag";
import "tags/todays/deliveries/date-ui.tag";
import "tags/todays/deliveries/checkbox.tag";
import "tags/myschedules/index.tag";
import "tags/users/index.tag";
import "tags/users/table.tag";
import "tags/heat_treatments/index.tag";
import "tags/heat_treatments/table.tag";
import "tags/clients/index.tag";
import "tags/clients/table.tag";
// import "tags/clients/locations.tag";
import "tags/clients/info.tag";
import "tags/orders/index.tag";
import "tags/orders/table.tag";
import "tags/orders/info.tag";
import "tags/orders/info-expandable.tag";
import "tags/orders/today.tag";
import "tags/orders/today-calendar.tag";
import "tags/orders/histories.tag";
import "tags/orders/result-checking-jobno.tag";
import "tags/orders/result-checking-orders-csv.tag";
import "tags/orders/warnings.tag";
import "tags/tasks/today.tag";
import "tags/tasks/delivered-calendar.tag";
import "tags/tasks/delivered-cell.tag";
import "tags/tasks/delivered-count.tag";
import "tags/tasks/delivered-total.tag";
import "tags/tasks/schedules-text.tag";
import "tags/tasks/schedules-calendar.tag";
import "tags/tasks/schedules-cell.tag";

import "tags/planner/title.tag";
import "tags/orders/planner-on-orders-show.tag";
import "tags/orders/basic-approvals.tag";
import "tags/orders/approvals/stamp.tag";
import "tags/orders/planner/header.tag";
import "tags/orders/planner/orders.tag";
import "tags/orders/planner/props.tag";
import "tags/orders/planner/lines.tag";
import "tags/orders/planner/line.tag";
import "tags/orders/planner/line-calendar.tag";
import "tags/orders/planner/schedules.tag";
import "tags/orders/planner/scroll.tag";
import "tags/orders/planner/warnings.tag";
import "tags/orders/planner/search-tags.tag";
import "tags/orders/planner/show-all-phases.tag";
import "tags/orders/planner/schedules/cell.tag";
import "tags/orders/planner/schedules/memo.tag";
import "tags/orders/planner/dialog/create-schedule.tag";
import "tags/orders/planner/dialog/save-tasks-memo.tag";
import "tags/orders/planner/dialog/tooltip-schedule.tag";
import "tags/orders/planner/dialog/tooltip-orders-phase.tag";
import "tags/orders/planner/dialog/line-menu.tag";
import "tags/orders/planner/dialog/update-under.tag";
import "tags/orders/planner/dialog/update-status.tag";
import "tags/orders/planner/line-ui.tag";
import "tags/orders/planner/deadline.tag";
import "tags/orders/planner/line-ui-uneditable.tag";
import "tags/orders/planner/date-ui.tag";
import "tags/orders/planner/line-back.tag";
import "tags/orders/planner/line-forward.tag";
import "tags/orders/planner/line-ui/menu.tag";
import "tags/orders/planner/line-ui/cells.tag";
import "tags/orders/planner/line-ui/ind-cell.tag";
import "tags/orders/planner/line-ui/schedules.tag";
import "tags/orders/planner/line-ui/schedules-uneditable.tag";
import "tags/orders/planner/line-ui/schedules-cell.tag";
import "tags/orders/planner/line-ui/schedules-cell-uneditable.tag";
import "tags/orders/planner/line-ui/schedules-left.tag";
import "tags/orders/planner/line-ui/schedules-right.tag";
import "tags/orders/planner/task/editor.tag";
import "tags/orders/planner/task/indicators.tag";
import "tags/orders/planner/tooltip/detail.tag";
import "tags/orders/planner/tooltip/orders-phase.tag";

import "tags/materials/index.tag";
import "tags/materials/table.tag";
import "tags/products/index.tag";
import "tags/products/table.tag";
import "tags/teams/index.tag";
import "tags/teams/table.tag";
import "tags/todos/index.tag";
import "tags/todos/table.tag";
import "tags/locations/index.tag";
import "tags/locations/table.tag";
import "tags/locations/people.tag";
import "tags/delivery_options/index.tag";
import "tags/delivery_options/table.tag";
import "tags/planner/index.tag";
import "tags/comments/index.tag";
import "tags/comments/comment.tag";
import "tags/comments/notifications.tag";
import "tags/notifications/index.tag";
import "tags/notifications/header.tag";
import "tags/notifications/table.tag";
import "tags/notifications/item.tag";
import "tags/notifications/items/common.tag";
import "tags/notifications/items/created-comment.tag";
import "tags/notifications/items/to-seller-schedule-changed.tag";
import "tags/notifications/items/to-person-in-charge-schedule-changed.tag";
import "tags/notifications/read-indicator.tag";
import "tags/calendars/two_weeks.tag";
import "tags/calendars/daily.tag";
import "tags/calendars/material_lots.tag";
import "tags/calendars/phase.tag";
import "tags/calendars/date-ui.tag";

import "tags/devs/gen-calendar.tag";

// ############  turbolinks  ############
var Turbolinks = require("turbolinks")
Turbolinks.start()
// ############  app  ############
import App  from "apps/application";
window["App"] = App;
import {
  faEdit,
  faTrash,
  faThumbtack,
  faExclamation,
  faInfo,
  faCheck,
  faCheckCircle,
  faPlus,
  faDownload
} from "@fortawesome/free-solid-svg-icons"
App.addFontAwesomeIcons(
  faEdit,
  faTrash,
  faThumbtack,
  faExclamation,
  faInfo,
  faCheck,
  faCheckCircle,
  faPlus,
  faDownload
)
App.init();
